import { type Static, Type } from "@sinclair/typebox"
import { AuthoredCardSchema } from "./cards"
import { IsoTimestampSchema } from "./common"

export const BasicBattleBotCardSchema = Type.Composite([
  AuthoredCardSchema,
  Type.Object({
    id: Type.Literal("basic_battle_bot"),
    kind: Type.Literal("starter"),
  }),
])

export type BasicBattleBotCard = Static<typeof BasicBattleBotCardSchema>

export const BetterBattleBotCardSchema = Type.Composite([
  AuthoredCardSchema,
  Type.Object({
    id: Type.Literal("better_battle_bot"),
    kind: Type.Literal("better_battle_bot"),
  }),
])

export type BetterBattleBotCard = Static<typeof BetterBattleBotCardSchema>

export const SparkBotCardSchema = Type.Composite([
  AuthoredCardSchema,
  Type.Object({
    id: Type.Literal("spark_bot"),
    kind: Type.Literal("starter"),
  }),
])

export type SparkBotCard = Static<typeof SparkBotCardSchema>

export const SystemBattleBotsConfigSchema = Type.Object({
  basicBattleBot: BasicBattleBotCardSchema,
  sparkBot: SparkBotCardSchema,
  betterBattleBot: BetterBattleBotCardSchema,
  updatedAt: IsoTimestampSchema,
})

export type SystemBattleBotsConfig = Static<typeof SystemBattleBotsConfigSchema>

export const SystemBattleBotsSyncEnvelopeSchema = Type.Object({
  record: SystemBattleBotsConfigSchema,
})

export type SystemBattleBotsSyncEnvelope = Static<
  typeof SystemBattleBotsSyncEnvelopeSchema
>

export const SystemBattleBotsSyncResponseSchema =
  SystemBattleBotsSyncEnvelopeSchema

export type SystemBattleBotsSyncResponse = Static<
  typeof SystemBattleBotsSyncResponseSchema
>
